import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import InstitutionsUniversitiesPage from '../../components/InstitutionUniversities/InstitutionsUniServices';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import fetchUtil from '../../utils/fetchUtil';

const InstitutionsUniversities: NextPage = (props: any) => {
  const { meta } = props?.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#B8AAEE');
    customStyle.setProperty('--navbar-menu-color', '#0E1B2C')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <InstitutionsUniversitiesPage {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/services-institutes`, 'GET', {}, '', false)
  return {
    props: { pageData }
  };
}

export default InstitutionsUniversities;